import GridContainer from "components/UI/Grid/GridContainer.js";
import AnalysisTable from "./components/AnalysisTable";

export default function Analysis() {
  return (
    <GridContainer>
      <AnalysisTable />
    </GridContainer>
  );
}
